import { useTranslation } from 'react-i18next'

const SUPPORTED = ['en', 'pt-BR'] as const
type Locale = (typeof SUPPORTED)[number]

export function LocaleSwitcher() {
  const { t, i18n } = useTranslation()
  const current = (SUPPORTED as readonly string[]).includes(i18n.language)
    ? (i18n.language as Locale)
    : 'en'

  return (
    <label className="inline-flex items-center gap-2 text-sm">
      <span className="opacity-70">{t('language.label')}</span>
      <select
        value={current}
        onChange={(event) => {
          void i18n.changeLanguage(event.target.value)
        }}
        className="rounded border px-2 py-1 bg-transparent"
        style={{ borderColor: 'var(--color-border)' }}
      >
        {SUPPORTED.map((locale) => (
          <option key={locale} value={locale}>
            {t(`language.${locale}`)}
          </option>
        ))}
      </select>
    </label>
  )
}
